import { Radio, Stack, styled, Typography } from '@mui/material';

export type LaunchStatusFilter = 'all' | 'confirmed' | 'draft';

type AvailScheduleRowExpandFiltersProps = {
  launchCount: number;
  selectedStatus: LaunchStatusFilter;
  onStatusChange: (status: LaunchStatusFilter) => void;
};

const FILTER_OPTIONS: { label: string; value: LaunchStatusFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'confirmed' },
  { label: 'Drafts', value: 'draft' }
];

const AvailScheduleRowExpandFilters = ({ launchCount, selectedStatus, onStatusChange }: AvailScheduleRowExpandFiltersProps) => (
  <ExpandedHeader>
    <StyledLaunchCount>All Launches ({launchCount})</StyledLaunchCount>
    <FilterBar direction="row" alignItems="center" spacing={2}>
      <Typography>Filter:</Typography>
      {FILTER_OPTIONS.map(({ label, value }) => (
        <FilterOption key={value} direction="row" alignItems="center" spacing={0.75}>
          <Radio size="small" checked={selectedStatus === value} onChange={() => onStatusChange(value)} />
          <Typography>{label}</Typography>
        </FilterOption>
      ))}
    </FilterBar>
  </ExpandedHeader>
);

export default AvailScheduleRowExpandFilters;

const ExpandedHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(1.5, 3)};
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
`;

const StyledLaunchCount = styled(Typography)`
  font-weight: 700;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
`;

const FilterBar = styled(Stack)`
  .MuiTypography-root {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  }

  .MuiRadio-root {
    padding: ${({ theme }) => theme.spacing(0.25)};
  }
`;

const FilterOption = styled(Stack)`
  color: ${({ theme }) => theme.palette.text.primary};
`;
